
  var _styles = {
  "team-info-captain": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "position": "relative",
    "marginRight": "0.48rem",
    "height": "1.28rem",
    "overflow": "hidden"
  },
  "team-info-captain-badge": {
    "position": "absolute",
    "top": "0.85333rem",
    "backgroundColor": "rgb(17,17,17)",
    "borderRadius": "0.12rem",
    "paddingTop": "0.08rem",
    "paddingRight": "0.13333rem",
    "paddingBottom": "0.08rem",
    "paddingLeft": "0.13333rem"
  },
  "team-info-captain-text": {
    "color": "rgb(255,255,255)",
    "fontSize": "0.26667rem",
    "lineHeight": "0.26667rem"
  }
};



  module.exports = _styles;
  